const v = {
  name: "CountryContainer",
  props: {
    countries: {
      type: Array,
      required: !0
    },
    content: {
      type: Array,
      required: !0
    }
  },
  computed: {
    currentCountryCode() {
      const e = this.$store.getters["frontend/currentCountryCode"];
      return e === void 0 && console.warn('[@made-people/nuxt-storyblok-country-container]: No "frontend/currentCountryCode" found in Vuex store. Is it registered?'), e;
    },
    blocks() {
      return this.countries.includes("_all_countries") || this.currentCountryCode !== void 0 && this.countries.includes(this.currentCountryCode) ? this.content : [];
    }
  }
};
var h = function() {
  var e = this, o = e.$createElement, u = e._self._c || o;
  return u("div", {
    staticClass: "country-container",
    staticStyle: {
      display: "contents"
    }
  }, [e._l(e.blocks, function(i) {
    return [u(i.component, e._b({
      directives: [{
        name: "editable",
        rawName: "v-editable",
        value: i,
        expression: "block"
      }],
      tag: "component",
      attrs: {
        "storyblok-uid": i._uid
      }
    }, "component", i, !1))];
  })], 2);
}, y = [];
function m(e, o, u, i, s, a, c, f) {
  var n = typeof e == "function" ? e.options : e;
  o && (n.render = o, n.staticRenderFns = u, n._compiled = !0), i && (n.functional = !0), a && (n._scopeId = "data-v-" + a);
  var r;
  if (c ? (r = function(t) {
    t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !t && typeof __VUE_SSR_CONTEXT__ < "u" && (t = __VUE_SSR_CONTEXT__), s && s.call(this, t), t && t._registeredComponents && t._registeredComponents.add(c);
  }, n._ssrRegister = r) : s && (r = f ? function() {
    s.call(this, (n.functional ? this.parent : this).$root.$options.shadowRoot);
  } : s), r)
    if (n.functional) {
      n._injectStyles = r;
      var C = n.render;
      n.render = function(p, l) {
        return r.call(l), C(p, l);
      };
    } else {
      var d = n.beforeCreate;
      n.beforeCreate = d ? [].concat(d, r) : [r];
    }
  return {
    exports: e,
    options: n
  };
}
const _ = {};
var $ = /* @__PURE__ */ m(v, h, y, !1, b, null, null, null);
function b(e) {
  for (let o in _)
    this[o] = _[o];
}
const R = /* @__PURE__ */ function() {
  return $.exports;
}();
export {
  R as default
};
//# sourceMappingURL=country-container.js.map
